export default {
  "nav.home": "Accueil",
  "nav.categories": "Catégories",
  "nav.guides": "Guides",
  "nav.faq": "FAQ",
  "nav.shopGuide": "Guide d'achat",

  "hero.badge": "Centre de ressources USFans Spreadsheet",
  "hero.title": "USFans Spreadsheet : trouvez produits, vendeurs et ressources plus vite",
  "hero.subtitle": "Découvrez les ressources USFans Spreadsheet, les guides vendeurs, la recherche de produits, le QC, les frais de livraison, les infos entrepôt, les avis, les coupons et les guides de sécurité, le tout au même endroit.",
  "hero.ctaPrimary": "Découvrir USFans Spreadsheet",
  "hero.ctaSecondary": "Voir les guides USFans",
  "hero.note": "Parcourez les catégories ci-dessous et accédez directement à la boutique principale.",

  "cat.title": "Parcourir les catégories de produits",
  "cat.subtitle": "Choisissez une catégorie pour l'ouvrir sur le site principal. Utilisez le menu déroulant ou appuyez sur un bouton ci-dessous.",
  "cat.dropdownLabel": "Choisir une catégorie",
  "cat.dropdownPlaceholder": "Sélectionner une catégorie…",
  "cat.open": "Ouvrir sur le site principal",

  "cat.shoes": "Chaussures",
  "cat.hoodies": "Sweats à capuche/Pulls",
  "cat.tshirts": "T-shirts",
  "cat.jackets": "Vestes",
  "cat.pants": "Pantalons/Shorts",
  "cat.headwear": "Couvre-chefs",
  "cat.sets": "Ensembles",
  "cat.underwear": "Sous-vêtements",
  "cat.jersey": "Maillots",
  "cat.accessories": "Accessoires",
  "cat.bags": "Sacs",
  "cat.belts": "Ceintures",
  "cat.perfumes": "Parfums",
  "cat.other": "Autres articles",

  "about.title": "Qu'est-ce que USFans Spreadsheet ?",
  "about.p1": "USFans Spreadsheet est un catalogue organisé qui regroupe chaussures, sweats à capuche, t-shirts, maillots, accessoires et plus encore dans une liste unique facile à parcourir. Au lieu de fouiller toute la boutique, vous allez directement à la section voulue.",
  "about.p2": "Il est conçu pour faire gagner du temps : comparez les produits côte à côte, consultez les notes des vendeurs et comprenez la livraison avant d'acheter. Voyez-le comme un raccourci de recherche qui vous mène aux bons produits du site principal.",

  "features.title": "Ressources USFans populaires",
  "features.subtitle": "Des guides pour acheter plus malin et en toute sécurité.",
  "features.review.title": "Avis USFans",
  "features.review.desc": "Ce que disent les acheteurs des produits, des vendeurs et de l'expérience globale.",
  "features.shipping.title": "Frais de livraison",
  "features.shipping.desc": "Comprenez les options de livraison, les infos entrepôt et les délais.",
  "features.coupon.title": "Coupons et réductions",
  "features.coupon.desc": "Astuces pour trouver des économies, des coupons et des codes promo.",
  "features.safety.title": "Sécurité et légitimité",
  "features.safety.desc": "USFans est-il légitime ? Conseils pratiques de sécurité et de vérification.",

  "guides.title": "Derniers guides",
  "guides.subtitle": "Des articles originaux et approfondis autour de USFans Spreadsheet.",
  "guides.readMore": "Lire l'article",

  "cta.title": "Prêt à parcourir tout le catalogue ?",
  "cta.subtitle": "Ouvrez la boutique principale USFans pour voir tous les produits, les prix actuels et finaliser votre commande.",
  "cta.primary": "USFans Spreadsheet",
  "cta.secondary": "Acheter Maintenant",

  "faq.title": "Questions fréquentes",
  "faq.q1": "Qu'est-ce que USFans Spreadsheet ?",
  "faq.a1": "C'est un catalogue de produits organisé qui regroupe vêtements de rue et produits pour fans par catégorie, en renvoyant vers la boutique principale pour l'achat.",
  "faq.q2": "Est-ce gratuit à parcourir ?",
  "faq.a2": "Oui, parcourir les catégories est simple. Les prix et le paiement se font sur le site principal.",
  "faq.q3": "Comment acheter un article ?",
  "faq.a3": "Choisissez une catégorie, ouvrez-la sur le site principal et finalisez-y votre commande.",
  "faq.q4": "USFans est-il légitime ?",
  "faq.a4": "Vérifiez toujours la boutique officielle, les modes de paiement et les conditions avant d'acheter, et évitez les sites qui imitent l'original.",

  "footer.tagline": "Une ressource informative indépendante sur USFans Spreadsheet.",
  "footer.explore": "Explorer",
  "footer.resources": "Ressources",
  "footer.mainSite": "Site principal",
  "footer.disclaimer": "Ce site est une ressource informative indépendante. Les informations peuvent évoluer avec le temps. Vérifiez toujours les informations importantes avant tout achat, paiement ou partage de données personnelles.",
  "footer.rights": "Tous droits réservés.",
};